import React, { Component } from 'react';
import { Button, Modal, Table, Menu, Dropdown, Icon } from 'antd';
import moment from 'moment';
import axios from '~/axios';


export default class SessionsTable extends Component {
    constructor(props) {
        super(props);
        // this.showSendDialog = this.showSendDialog.bind(this);
        this.editSession = this.editSession.bind(this);
    }

    /**
     * Downloads a list of everyone enrolled in a session in CSV format.
     * @param {object} data - The session's data.
     */
    downloadClassList(data) {
        axios.get('/api/classlist/' + data.sessionID, { responseType: 'blob' }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            const strippedCourseTitle = data.course.title.substring(0, data.course.title.indexOf('<'));
            const fileName = strippedCourseTitle + " " + moment(data.startTime).format("YYYY-MM-DD") + " class list.csv";
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        });
    }

    /**
     * Opens a modal to edit session.
     * @param {object} data - The session's data.
     */
    editSession(data) {
        console.log("Handling Edit Session");
        console.log(data);
        console.log(this);
        const component = this;
        component.props.showEditSessionForm(data.sessionID);
    }

    /**
     * Shows a modal asking to confirm session deletion.
     * @param {object} data - The session's data.
     */
    deleteSession(data) {
        const component = this;
        Modal.confirm({
            title: 'Delete session?',
            content: 'Are you sure you want to delete this session? This action cannot be undone, and will affect any submissions registered in this session.',
            okText: 'Delete Session',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk() {
                // Deletes the selected session.
                axios.delete('/api/sessions/' + data.sessionID).then(response => {
                    console.log(response)
                    component.props.handleRemoveSession(data.sessionID);
                }).catch(error => {
                    console.error(error)
                });
            },
            onCancel() {
            },
        });
    }

    onChange(pagination, filters, sorter, extra) {
        // console.log('params', pagination, filters, sorter, extra);
        // const component = this;
        // console.log(filters);
        this.props.handleFilterSessions(filters);
    }


    render() {
        const columns = [{
            title: 'Date',
            key: 'date',
            render: (data, record) => <span>{ moment(record.startTime).format('MMMM Do, YYYY') }</span>,
            filterMultiple: false,
            defaultFilteredValue: ['hideOldSessions'],
            // onFilter: (value, record) => console.log(value),//
            filters: [
                {
                    text: 'Hide Past Sessions',
                    value: 'hideOldSessions',
                },
                {
                    text: 'Show All Sessions',
                    value: 'showAll',
                },
            ],
        }, {
            title: 'Time',
            key: 'time',
            render: (data, record) =>
                <span>{ moment(record.startTime).format('LT') } - { moment(record.endTime).format('LT') }</span>
        }, {
            title: 'Site',
            dataIndex: 'site',
            key: 'site',
        }, {
            title: 'Location',
            key: 'location',
            dataIndex: 'location',
        }, {
            title: 'Registered/Capacity',
            key: 'capacity',
            render: (data, record) => <span>{ record.registered } / { record.capacity }</span>
        }, {
            title: 'Class List',
            key: 'classlist',
            render: (data, record) => <Button
                onClick={ this.downloadClassList.bind(this, data, record) }>Download</Button>
            // }, {
            //   title: 'Delete Session',
            //   key: 'delete',
            //   render: (data, record) => <Button type="danger" onClick={this.deleteSession.bind(this, data, record)}>Delete Session</Button>
        }, {
            title: 'Actions',
            key: 'actions',
            // width: 50,
            render: (data, record) => {
                const actionMenu = (
                    <Menu>
                        <Menu.Item key="1" onClick={ this.editSession.bind(this, data, record) } icon="edit">
                            <Icon type="edit"/>Edit
                        </Menu.Item>
                        <Menu.Divider/>
                        <Menu.Item key="2" onClick={ this.deleteSession.bind(this, data, record) } icon="delete"
                                   type="danger">
                            <Icon type="delete"/>Delete
                        </Menu.Item>
                    </Menu>
                );

                return (
                    <Dropdown overlay={ actionMenu } trigger={ ['click'] }>
                        <a className="ant-dropdown-link dashboard-action" href="#">
                            <Icon type="more"/>
                        </a>
                    </Dropdown>
                )
            }
        }];

        return (
            <Table loading={ this.props.loading } columns={ columns } dataSource={ this.props.sessions }
                   rowKey="sessionID"
                   onChange={ (pagination, filters, sorter, extra) => this.onChange(pagination, filters, sorter, extra) }/>
        );
    }
}
